import React from "react";
import { Link } from "react-router-dom";

const AboutUs = ({ data, registerUrl }) => {
  console.log("===data====", data, registerUrl)
  return (
    <div className="about__two section-padding" id="aboutus">
      <img
        className="about__two-shape-one"
        src={"/img/shape/about-1.png"}
        alt="about-shape"
      />
      <img
        className="about__two-shape-two dark-n"
        src={"/img/shape/about-2.png"}
        alt="about-shape"
      />

      <div style={{ textAlign: 'center' }}>
        <h2  className="responsive-heading">Welcome to Algomoneo</h2>
        <p  className="responsive-paragraph">Click the button below to join us!</p>
        <Link to={registerUrl}>
          <button className="register-btn">Register Now</button>
        </Link>
      </div>

      {/* {data && <div dangerouslySetInnerHTML={{ __html: data }}></div>} */}
      {/* {data && <div dangerouslySetInnerHTML={{ __html: data }}></div>} */}
    </div>
  );
};

export default AboutUs;
